
import { useEffect } from 'react';
import Navbar from '../../components/feature/Navbar';
import SharedFooter from '../../components/feature/SharedFooter';
import AboutHero from './components/AboutHero';
import OurStory from './components/OurStory';
import Mission from './components/Mission';
import Team from './components/Team';
import Values from './components/Values';
import AboutCTA from './components/AboutCTA';

export default function AboutPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <AboutHero />
      <OurStory />
      <Mission />
      <Team />
      <Values />
      <AboutCTA />
      <SharedFooter />
    </div>
  );
}
